import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import numberTracksUtils from './utils/numberTracks.utils'
import numberUtils from './utils/number.utils'


export default class NumberTracksLevelComponent extends BaseLevel {
    onEnter = () => {
        const firstValue = +this.state.quantities.value_1
        const secondValue = +this.state.quantities.answer
        const answer = this.state.answer
        const type = this.props.level.settings.type
        const stepSize = this.props.level.settings.step_size
        const isUp = firstValue < secondValue ? true : false
        let answerNumber = this.state.answerNumber || 1
        let result = 0
        let roundsCount = Math.abs((secondValue - firstValue)) / stepSize
        if (type === 'missing') {
            result = secondValue
        } else {
            result = isUp ? +firstValue + stepSize * answerNumber : firstValue - stepSize * answerNumber
        }
        if (+answer === +result) {
            if (type === 'missing') {
                this.setState({ wrongAnswer: false, answer: '?', answerNumber: 1 })
                this.props.onRoundComplete()
                this.generateLevel()
                this.onRoundComplete()
            } else {
                if (answerNumber >= roundsCount) {
                    this.setState({ wrongAnswer: false, answer: '?', answerNumber: 1 })
                    this.props.onRoundComplete()
                    this.generateLevel()
                    this.onRoundComplete()
                } else {
                    this.onRoundComplete()
                    this.setState({ answer: '?', answerNumber: answerNumber + 1 })
                }
            }

        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }

    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const answerNumber = this.state.answerNumber || 1
        const answerString = settings.show_sum ? numberUtils.getNumberString(settings, quantities, answer) : answer
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answerString} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && numberTracksUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, answerNumber)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/numberTracks.levels.js